import style from "../../../assets/scss/sub/startGuide.module.scss";
import {StartGuideOptions} from "./StartGuideOptions";
import {useTranslation} from "react-i18next";

export function OrganStartGuide() {
    const { t } = useTranslation("startGuide");

    return (
        <div className={style.processOrganContainerWrapper}>
            {/* 01 코드 받기 */}
            <StartGuideOptions img={"organ_info_01"} idx={1} title={t('organ.step1.title')} containerStyle={"balanceBottom"}>
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>
                        {t('organ.step1.desc')}
                    </li>
                </ul>
            </StartGuideOptions>

            {/* 02 다운로드 */}
            <div className={style.blueBg}>
                <StartGuideOptions img={"organ_info_02"} idx={2} title={t('organ.step2.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('organ.step2.desc')}
                        </li>
                        <li className={style.listSubItem}>{t('organ.step2.subDesc')}</li>
                    </ul>
                </StartGuideOptions>

                {/* 03 로그인 */}
                <StartGuideOptions img={"organ_info_03"} idx={3} title={t('organ.step3.title')} >
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('organ.step3.desc')}
                        </li>
                        <li className={style.listSubItem}>{t('organ.step3.subDesc')}</li>
                    </ul>
                </StartGuideOptions>

                {/* 04 검사진행 */}
                <StartGuideOptions img={"organ_info_04"} idx={4} title={t('organ.step4.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('organ.step4.desc')}
                        </li>
                    </ul>
                </StartGuideOptions>
            </div>

            {/* 05 결과보기 */}
            <StartGuideOptions img={"organ_info_05"} idx={5} title={t('organ.step5.title')} containerStyle={'balanceTop'}>
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>{t('organ.step5.desc')}</li>
                </ul>
            </StartGuideOptions>
        </div>
    )
}